import React, { useEffect } from "react";
import { string } from "prop-types";
import { usePageData } from "@insightfulscience/smart-react/hocs/DiPageHoC";
import useFormAction from "@insightfulscience/smart-react/hooks/useFormAction";
import Alert from "@insightfulscience/atomic-react/Alert";
import getPlasmidContentMap from "../../providers/getPlasmidContentMap";

const PlasmidInteractiveMap = ({ setID, plasmidID, plasmidFilename }) => {
	const { plasmidInteractiveMap } = usePageData();
	const [loadPlasmidContentMap, { result }] = useFormAction(getPlasmidContentMap);
	useEffect(() => {
		loadPlasmidContentMap(setID, plasmidID);

		return () => {
			// refMapContainer.current = null;
		};
	}, []);
	return (
		<>
			<div className="viewport" id="map-content">
				{typeof plasmidInteractiveMap !== "undefined" && plasmidInteractiveMap ? (
					<div
						id="map1"
						className="sg-map-placeholder"
						data-relative-path={`${setID}/${plasmidID}`}
						data-filename={plasmidFilename}
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{ __html: result ?? plasmidInteractiveMap }}
					/>
				) : (
					<Alert status="error" title="Something went wrong" className="text-left mt-10">
						Failed to fetch plasmid content map.
					</Alert>
				)}
			</div>
		</>
	);
};

PlasmidInteractiveMap.propTypes = {
	setID: string,
	plasmidID: string,
	plasmidFilename: string,
};

export default PlasmidInteractiveMap;
